import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

interface AdminRoute {
  component: React.ComponentType<any>;
}

const AdminRoute: React.FC<AdminRoute> = ({ component: Component }) => {
  const navigate = useNavigate();
  const { user, isLoggedIn } = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (isLoggedIn && user.type !== "admin") {
      navigate("/");
    }
  }, [isLoggedIn]);

  if (isLoggedIn && user.type === "admin") {
    return <Component />;
  }
};

export default AdminRoute;
